import { useTranslation } from 'react-i18next';

import Hr from '../../components/Style/hr';
import PersonnalAndAddressForm from '../../components/Forms/personnal-and-address-form';
import TitlePaymentLink from '../../components/title-payment-link';

export default function StepPersonnalInfosFormPaymentLink({ returnedData, initialFormData }) {
    const { t } = useTranslation();

    const handleReturnedData = (data) => {
        returnedData(data);
    };

    return (
        <>
            <TitlePaymentLink title={t('pagePaymentLink.step2.welcomeMessage')} description={t('pagePaymentLink.step2.description')} step="2" />
            <Hr />
            <PersonnalAndAddressForm returnedData={handleReturnedData} initialFormData={initialFormData} />
        </>
    );
}